import React, { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { map } from 'lodash';
import './RoutingTabs.scss'; // Import the RoutingTabs.scss file
import { Colors } from '../styles/Colors';
import {UserReactContext} from "../../contexts/UserContext";

/**
 * LocalTabs component for displaying tabs with content
 *
 * @param {object} props - Component props
 * @param {Array} props.tabs - Array of tab objects with value, label, icon (optional), and content
 * @param {string} props.defaultTab - Optional default tab value to select initially
 * @param {string} props.variant - Optional Material UI Tabs variant ('standard', 'scrollable', 'fullWidth')
 * @param {boolean} props.scrollButtons - Optional flag to show/hide scroll buttons (default: true)
 * @param {function} props.onTabChange - Optional callback when tab changes
 * @returns {JSX.Element} The LocalTabs component
 */
export const LocalTabs = ({ tabs, defaultTab, variant = "scrollable", scrollButtons = true, onTabChange }) => {
    const [currentTab, setCurrentTab] = useState(defaultTab || tabs[0]?.value);
    const userCntext = React.useContext(UserReactContext);

    const handleChange = (event, newValue) => {
        setCurrentTab(newValue);
        if (onTabChange) {
            onTabChange(newValue);
        }
    };

    const validTabs = tabs.filter(tab => {
        if (tab.onlyForCompanyAdmin) {
            return userCntext.user?.isCompanyAdmin;
        }
        return true;
    });

    // If there's only one tab, always show it regardless of currentTab state
    const activeTab = validTabs.length === 1 ? validTabs[0].value : currentTab;

    return (
        <div className="Tabs"> {/* Use the same class name as in RoutingTabs */}
            {/* Only show tabs selector if there's more than one valid tab */}
            {validTabs.length > 1 && (
                <Tabs
                    value={currentTab}
                    onChange={handleChange}
                    variant={variant}
                    scrollButtons={scrollButtons}
                    allowScrollButtonsMobile={scrollButtons}
                >
                    {map(validTabs, (tab) => (
                        <Tab
                            icon={tab.icon}
                            iconPosition="start"
                            label={tab.label}
                            key={tab.value}
                            value={tab.value}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 'bold',
                                fontSize: '24px',
                                fontFamily: 'OpenSansCond',
                                '&.Mui-selected': {
                                    color: Colors['$menuItemText'],
                                },
                            }}
                        />
                    ))}
                </Tabs>
            )}
            <div className="routeContent"> {/* Use the same class name as in RoutingTabs */}
                {map(tabs, (tab) => (
                    tab.value === activeTab && <div key={tab.value}>{tab.content}</div>
                ))}
            </div>
        </div>
    );
};